import { z } from "zod";
import { optionalFilterString } from "@/schemas/filter.schema";

export const sessionsFilterSchema = z.object({
	search: optionalFilterString,
	period: optionalFilterString,
	cardId: optionalFilterString,
	stationId: optionalFilterString,
});

export type SessionsFilter = z.infer<typeof sessionsFilterSchema>;
